export const lightenColor = (hex?: string, amount = 20) => {
    if (hex == undefined) return;

    // Validate and clean hex
    hex = hex.replace('#', '');
    if (hex.length === 3) {
        hex = hex
            .split('')
            .map((char) => char + char)
            .join('');
    }

    if (!/^[0-9A-F]{6}$/i.test(hex)) {
        throw new Error('Invalid hex color');
    }

    // Convert to RGB
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);

    // Lighten
    const lighten = (color: number) =>
        Math.min(255, Math.round(color + (255 - color) * (amount / 100)));

    const newR = lighten(r);
    const newG = lighten(g);
    const newB = lighten(b);

    // Convert back to hex
    const toHex = (n: number) => n.toString(16).padStart(2, '0');
    return `#${toHex(newR)}${toHex(newG)}${toHex(newB)}`;
};
